export const textStyleFontSizeDropdownOptions = [
    {
        label: '8px',
        value: '8px'
    },
    {
        label: '9px',
        value: '9px'
    },
    {
        label: '10px',
        value: '10px'
    },
    {
        label: '11px',
        value: '11px'
    },
    {
        label: '12px',
        value: '12px'
    },
    {
        label: '14px',
        value: '14px'
    },
    {
        label: '16px',
        value: '16px'
    },
    {
        label: '18px',
        value: '18px'
    },
    {
        label: '20px',
        value: '20px'
    },
    {
        label: '22px',
        value: '22px'
    },
    {
        label: '24px',
        value: '24px'
    },
    {
        label: '26px',
        value: '26px'
    },
    {
        label: '28px',
        value: '28px'
    },
    {
        label: '36px',
        value: '36px'
    },
    {
        label: '48px',
        value: '48px'
    },
    {
        label: '72px',
        value: '72px'
    }
];
